// Helper to request resized / reformatted variants from Shopify's image CDN.
// Shopify supports ?width, ?height, ?format on cdn.shopify.com URLs.

type Opts = {
  width?: number;
  height?: number;
  format?: "webp" | "jpg" | "png";
};

export function shopifyImg(url: string | undefined | null, opts: Opts = {}): string {
  if (!url) return "";
  // Only transform Shopify CDN URLs; leave others untouched.
  if (!/cdn\.shopify\.com/.test(url)) return url;

  try {
    const u = new URL(url);
    if (opts.width) u.searchParams.set("width", String(opts.width));
    if (opts.height) u.searchParams.set("height", String(opts.height));
    if (opts.format) {
      // Shopify prefers explicit extension swap for format; params also work for width.
      u.searchParams.set("format", opts.format);
    }
    return u.toString();
  } catch {
    return url;
  }
}
